import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Labels, SdfCardLabels } from '../../../app.models';
import { animate, style, transition, trigger } from '@angular/animations';
import { Store } from '@ngrx/store';
import {
  getSelectedLocationTrns,
  isLocationSelected,
} from '../../../store/transaction/transaction.selectors';
import { Observable } from 'rxjs';
import { LocationFinderService } from '../../../services/location-finder.service';
import { MgLocation } from '../../../models/location.model';
import { PaymentOptionType } from 'src/app/feature/payment-method/payment-method.models';

@Component({
  selector: 'app-payout-options',
  templateUrl: './payout-options.component.html',
  styleUrls: ['./payout-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        animate(
          '0.3s ease-in-out',
          style({ opacity: 0, transform: 'translateY(-20px)' })
        ),
      ]),
    ]),
  ],
})
export class PayoutOptionsComponent implements OnInit {
  @Output() changePaymentMethodEvent = new EventEmitter<PaymentOptionType>();
  @Input() enableSelectLocationBtn: boolean | null | undefined;
  @Input() selectedLocation: any = {};
  isNotificationContainerOpen: boolean = true;
  public isLocationSelected$: Observable<boolean>;
  public selectedLocation$: Observable<MgLocation>;
  sdfCardLabels: SdfCardLabels;
  public _google: any;
  @Input() public set google(map: any) {
    this._google = map;
  }
  public get google() {
    return this._google;
  }

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.sdfCardLabels = labels.stellar.sdfcard;
  }
  public get labels() {
    return this._labels;
  }

  @Input() flow: string;
  @Input() public selectedPaymentMethod: PaymentOptionType | null;
  @Input() public isPaymentOptionsEnabled: boolean;
  @Input() public isCashEnabled: boolean;
  @Input() public isDebitEnabled: boolean;
  @Input() public isBankAccountEnabled: boolean;
  @Input() public isPaymentOptionsSubtitleEnabled: boolean;

  constructor(
    private store: Store,
    public locationFinderService: LocationFinderService
  ) {}

  ngOnInit(): void {
    this.isLocationSelected$ = this.store.select(isLocationSelected);

    this.selectedLocation$ = this.store.select(getSelectedLocationTrns);
  }

  public emitChangePaymentMethodEvent(paymentMethod: PaymentOptionType): void {
    this.changePaymentMethodEvent.emit(paymentMethod)
  }
}
